import React, { useState, useEffect } from "react";
import axios from 'axios';
import { FaEnvelope, FaLock, FaUser, FaEye, FaEyeSlash } from "react-icons/fa";
import { endpoints } from "../Apis/endpoints";
import { BASE_URL } from "../Apis/endpoints";
import { useNavigate } from 'react-router-dom';

const Signup = () => {
    const [fullname, setFullname] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});
    const [authError, setAuthError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const navigate = useNavigate();

    const [isHeightMoreThan740, setIsHeightMoreThan740] = useState(false);

    useEffect(() => {
        const checkHeight = () => {
            setIsHeightMoreThan740(window.innerHeight > 740);
        };
        checkHeight();
        window.addEventListener('resize', checkHeight);
        return () => window.removeEventListener('resize', checkHeight);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = {};

        if (!fullname) newErrors.fullname = "Full name is required";
        if (!email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S/.test(email)) {
            newErrors.email = "Email is invalid";
        }

        if (!password) {
            newErrors.password = "Password is required";
        } else if (password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }

        if (password !== confirmPassword) {
            newErrors.confirmPassword = "Passwords do not match";
        }

        setErrors(newErrors);

        if (Object.keys(newErrors).length === 0) {
            try {
                const response = await axios.post(`${BASE_URL}${endpoints.SIGNUP}`, {
                    fullname,
                    email,
                    password,
                    confirm_password: confirmPassword,
                });

                console.log("Verification email sent:", response.data);
                setAuthError("");
                setSuccessMessage("Please check your email to verify your account and complete the signup process.");

                setTimeout(() => {
                    navigate('/login');
                }, 5000);
            } catch (error) {
                const emailError = error?.response?.data?.errors?.email;
                const messageError = error?.response?.data?.message;

                if (emailError) setAuthError(emailError);
                else if (messageError) setAuthError(messageError);
                else setAuthError("Error sending verification email. Please try again.");
                console.error("Error sending verification email:", error);
            }
        }
    };

    return (
        <div
            className="w-full min-h-screen flex flex-col justify-start items-center bg-white px-4 sm:px-8 md:px-10 pt-10"
            style={{
                flexDirection: "column",
                backgroundImage: "url('/images/background.svg')",
                backgroundSize: "100% auto",
                backgroundAttachment: isHeightMoreThan740 ? "fixed" : "scroll",
                overflowX: "hidden",
            }}
        >
            {successMessage && <p className="text-green-500 text-lg sm:text-2xl mt-2">{successMessage}</p>}
            {authError && <p className="text-red-500 text-sm sm:text-lg mb-4">{authError}</p>}

            <img src="/images/Transpoze_logo.svg" alt="Transpoze logo" className="mb-2 mt-4 max-w-[150px] sm:max-w-xs" />

            <h1
                className="text-[28px] sm:text-[36px] text-[#1E293B] font-extrabold text-center mt-4 mb-6"
                style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
            >
                Sign Up
            </h1>

            <form onSubmit={handleSubmit} className="font-semibold w-full max-w-xs sm:max-w-md space-y-5">
                <div>
                    <label className="block mb-2 text-[#1E293B]">Full Name</label>
                    <div className="flex items-center bg-[#ffffff] border border-gray-300 rounded-full">
                        <FaUser className="ml-4 text-[#475569]" />
                        <input
                            type="text"
                            placeholder="Enter your full name"
                            className="p-3 w-full rounded-full text-[#475569] focus:outline-none"
                            value={fullname}
                            onChange={(e) => setFullname(e.target.value)}
                        />
                    </div>
                    {errors.fullname && <p className="text-red-500 text-sm mt-1">{errors.fullname}</p>}
                </div>

                <div>
                    <label className="block mb-2 text-[#1E293B]">Email Address</label>
                    <div className="flex items-center bg-[#ffffff] border border-gray-300 rounded-full">
                        <FaEnvelope className="ml-4 text-[#475569]" />
                        <input
                            type="email"
                            placeholder="Enter your email address"
                            className="p-3 w-full rounded-full text-[#475569] focus:outline-none"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>
                    {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
                </div>

                <div>
                    <label className="block mb-2 text-[#1E293B]">Password</label>
                    <div className="flex items-center bg-[#ffffff] border border-gray-300 rounded-full">
                        <FaLock className="ml-4 text-[#475569]" />
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Enter your password"
                            className="p-3 w-full rounded-full text-[#475569] focus:outline-none"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="relative sm:mr-3 md:mr-4 mr-4 text-[#475569] focus:outline-none"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </button>
                    </div>
                    {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
                </div>

                <div>
                    <label className="block mb-2 text-[#1E293B]">Confirm Password</label>
                    <div className="flex items-center bg-[#ffffff] border border-gray-300 rounded-full">
                        <FaLock className="ml-4 text-[#475569]" />
                        <input
                            type={showPassword ? "text" : "password"}
                            placeholder="Confirm your password"
                            className="p-3 w-full rounded-full text-[#475569] focus:outline-none"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="relative sm:mr-3 md:mr-4 mr-4 text-[#475569] focus:outline-none"
                            onClick={() => setShowPassword(!showPassword)}
                        >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </button>
                    </div>
                    {errors.confirmPassword && <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>}
                </div>

                <button
                    type="submit"
                    className="bg-[#2C67F2] text-white p-3 rounded-full font-bold w-full hover:bg-blue-600 flex justify-center items-center"
                >
                    Sign Up
                    <img
                        src="/images/signout.svg"
                        alt="Sign Up Icon"
                        className="ml-2 w-4 h-4"
                    />
                </button>
            </form>

            <p className="mt-4 text-[#1E293B] font-semibold text-sm sm:text-base">
                Already have an account? <a href="/login" className="text-[#2C67F2] font-semibold hover:underline">Sign In</a>
            </p>

            <footer
                className="mt-auto w-full text-[#475569] font-semibold text-xs sm:text-sm flex justify-center items-center border-t border-[#CBD5E1] py-2"
            >
                Copyright {new Date().getFullYear()} Transpoze &copy;
            </footer>
        </div>
    );
};

export default Signup;
